// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IPVVerify_container__3H4wV {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.IPVVerify_card__pmEBA {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.IPVVerify_loader__qlrAO {
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #f86a6e;
    width: 50px;
    height: 50px;
    animation: IPVVerify_spin__WxvOT 1s linear infinite;
    margin: 20px auto;
}

@keyframes IPVVerify_spin__WxvOT {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.IPVVerify_message__w3pXH {
    margin: 20px 0;
    font-size: 18px;
    font-weight: 500;
}

.IPVVerify_countdown__IpKjb {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
    font-weight: normal;
}

.IPVVerify_success__-tZB5 {
    color: #28a745;
}

.IPVVerify_error__ZQ31\\+ {
    color: #dc3545;
}

.IPVVerify_icon__r0Bhp {
    font-size: 48px;
    margin-bottom: 20px;
}

.IPVVerify_successIcon__WS6xw {
    color: #28a745;
}

.IPVVerify_errorIcon__bw4eS {
    color: #dc3545;
}

/* ─── Mobile Completion Screen ───────────────────────────────────────────── */
.IPVVerify_mobileDoneContainer__cntKT {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 60%, #fff 100%);
    padding: 24px;
    font-family: 'Segoe UI', Arial, sans-serif;
}

.IPVVerify_mobileDoneCard__iKip1 {
    background: white;
    border-radius: 24px;
    padding: 40px 28px 36px;
    max-width: 380px;
    width: 100%;
    text-align: center;
    box-shadow: 0 12px 40px rgba(34, 197, 94, 0.15);
    border: 1.5px solid #bbf7d0;
    animation: IPVVerify_cardIn__ZJCjD 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes IPVVerify_cardIn__ZJCjD {
    from { transform: translateY(30px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
}

.IPVVerify_tickRing__KbgEO {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
}

.IPVVerify_tickSvg__iN8Jj {
    width: 100%;
    height: 100%;
}

.IPVVerify_tickCircle__RJ1ig {
    stroke-dasharray: 226;
    stroke-dashoffset: 226;
    animation: IPVVerify_drawCircle__VYbpf 0.7s ease forwards;
}

@keyframes IPVVerify_drawCircle__VYbpf {
    to { stroke-dashoffset: 0; }
}

.IPVVerify_tickPath__f9i\\+C {
    stroke-dasharray: 60;
    stroke-dashoffset: 60;
    animation: IPVVerify_drawTick__aBWMQ 0.4s ease 0.65s forwards;
}

@keyframes IPVVerify_drawTick__aBWMQ {
    to { stroke-dashoffset: 0; }
}

.IPVVerify_doneTitle__Zz77U {
    font-size: 24px;
    font-weight: 700;
    color: #15803d;
    margin: 0 0 8px;
}

.IPVVerify_doneSubtitle__edxut {
    font-size: 15px;
    color: #555;
    margin: 0 0 24px;
    line-height: 1.5;
}

.IPVVerify_doneInfoBox__RfDRm {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 12px;
    padding: 16px;
    text-align: left;
}

.IPVVerify_doneInfoIcon__mk4iv {
    font-size: 22px;
    flex-shrink: 0;
    margin-top: 1px;
}

.IPVVerify_doneInfoText__VXE0q {
    font-size: 14px;
    color: #166534;
    line-height: 1.6;
    margin: 0;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/organism/IPVVerify.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,mDAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,+EAA+E;AAC/E;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uEAAuE;IACvE,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,+CAA+C;IAC/C,2BAA2B;IAC3B,0EAAyD;AAC7D;;AAEA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AACpD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yDAAwC;AAC5C;;AAEA;IACI,KAAK,oBAAoB,EAAE;AAC/B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,6DAA4C;AAChD;;AAEA;IACI,KAAK,oBAAoB,EAAE;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n    padding: 20px;\n}\n\n.card {\n    background: white;\n    border-radius: 12px;\n    padding: 30px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 400px;\n    width: 100%;\n}\n\n.loader {\n    border: 4px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 4px solid #f86a6e;\n    width: 50px;\n    height: 50px;\n    animation: spin 1s linear infinite;\n    margin: 20px auto;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.message {\n    margin: 20px 0;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.countdown {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #666;\n    font-weight: normal;\n}\n\n.success {\n    color: #28a745;\n}\n\n.error {\n    color: #dc3545;\n}\n\n.icon {\n    font-size: 48px;\n    margin-bottom: 20px;\n}\n\n.successIcon {\n    color: #28a745;\n}\n\n.errorIcon {\n    color: #dc3545;\n}\n\n/* ─── Mobile Completion Screen ───────────────────────────────────────────── */\n.mobileDoneContainer {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 60%, #fff 100%);\n    padding: 24px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n}\n\n.mobileDoneCard {\n    background: white;\n    border-radius: 24px;\n    padding: 40px 28px 36px;\n    max-width: 380px;\n    width: 100%;\n    text-align: center;\n    box-shadow: 0 12px 40px rgba(34, 197, 94, 0.15);\n    border: 1.5px solid #bbf7d0;\n    animation: cardIn 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes cardIn {\n    from { transform: translateY(30px); opacity: 0; }\n    to   { transform: translateY(0);    opacity: 1; }\n}\n\n.tickRing {\n    width: 100px;\n    height: 100px;\n    margin: 0 auto 24px;\n}\n\n.tickSvg {\n    width: 100%;\n    height: 100%;\n}\n\n.tickCircle {\n    stroke-dasharray: 226;\n    stroke-dashoffset: 226;\n    animation: drawCircle 0.7s ease forwards;\n}\n\n@keyframes drawCircle {\n    to { stroke-dashoffset: 0; }\n}\n\n.tickPath {\n    stroke-dasharray: 60;\n    stroke-dashoffset: 60;\n    animation: drawTick 0.4s ease 0.65s forwards;\n}\n\n@keyframes drawTick {\n    to { stroke-dashoffset: 0; }\n}\n\n.doneTitle {\n    font-size: 24px;\n    font-weight: 700;\n    color: #15803d;\n    margin: 0 0 8px;\n}\n\n.doneSubtitle {\n    font-size: 15px;\n    color: #555;\n    margin: 0 0 24px;\n    line-height: 1.5;\n}\n\n.doneInfoBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    background: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    border-radius: 12px;\n    padding: 16px;\n    text-align: left;\n}\n\n.doneInfoIcon {\n    font-size: 22px;\n    flex-shrink: 0;\n    margin-top: 1px;\n}\n\n.doneInfoText {\n    font-size: 14px;\n    color: #166534;\n    line-height: 1.6;\n    margin: 0;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IPVVerify_container__3H4wV`,
	"card": `IPVVerify_card__pmEBA`,
	"loader": `IPVVerify_loader__qlrAO`,
	"spin": `IPVVerify_spin__WxvOT`,
	"message": `IPVVerify_message__w3pXH`,
	"countdown": `IPVVerify_countdown__IpKjb`,
	"success": `IPVVerify_success__-tZB5`,
	"error": `IPVVerify_error__ZQ31+`,
	"icon": `IPVVerify_icon__r0Bhp`,
	"successIcon": `IPVVerify_successIcon__WS6xw`,
	"errorIcon": `IPVVerify_errorIcon__bw4eS`,
	"mobileDoneContainer": `IPVVerify_mobileDoneContainer__cntKT`,
	"mobileDoneCard": `IPVVerify_mobileDoneCard__iKip1`,
	"cardIn": `IPVVerify_cardIn__ZJCjD`,
	"tickRing": `IPVVerify_tickRing__KbgEO`,
	"tickSvg": `IPVVerify_tickSvg__iN8Jj`,
	"tickCircle": `IPVVerify_tickCircle__RJ1ig`,
	"drawCircle": `IPVVerify_drawCircle__VYbpf`,
	"tickPath": `IPVVerify_tickPath__f9i+C`,
	"drawTick": `IPVVerify_drawTick__aBWMQ`,
	"doneTitle": `IPVVerify_doneTitle__Zz77U`,
	"doneSubtitle": `IPVVerify_doneSubtitle__edxut`,
	"doneInfoBox": `IPVVerify_doneInfoBox__RfDRm`,
	"doneInfoIcon": `IPVVerify_doneInfoIcon__mk4iv`,
	"doneInfoText": `IPVVerify_doneInfoText__VXE0q`
};
export default ___CSS_LOADER_EXPORT___;
